import { gql } from '@apollo/client';

export interface CrossPitchRow {
    personId: string;
    jobId: string;
    assignee: string;
    user: {
        id: string;
        name: string;
        username: string;
    };
    candidate?: {
        person: { id: string; name: string };
        job: { id: string; title: string; client: { id: string; name: string } };
        job_stage?: { label: string };
    };
}

export const CROSS_PITCH_ROWS = gql`
    query CrossPitches {
        crossPitches: cross_pitches_per_person_assignee(order_by: { assignee: asc }) {
            personId
            jobId
            assignee
            user {
                id
                name(path: "full")
                username
            }
            candidate {
                person {
                    id
                    name(path: "full")
                }
                job {
                    id
                    title
                    client {
                        id
                        name
                    }
                }
                job_stage {
                    label
                }
            }
        }
    }
`;
